import { TRAINING_USER_LOCAL_STORAGE_KEY } from 'modules/training/modules/training-users/constants'
import getItemLocalStorageUtil from 'modules/local-storage/get-item/index.js'

export function getNewCustomerDiscountExpiresAtFromLocalStorageUtil () {
  return getItemLocalStorageUtil(TRAINING_USER_LOCAL_STORAGE_KEY.NEW_CUSTOMER_DISCOUNT_EXPIRES_AT)
}
